import { LocalStorageWrapper } from '@/utils';

type TKey = 'isWalletConnected' | 'chainName' | 'providerName';

const storage = new LocalStorageWrapper<TKey>('talentsLive');

export default storage;
